import { FC } from 'react';
import styled from 'styled-components';
import { List as AntList } from 'antd';

import { ListItemProps, ListProps } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const List = styled<FC<ListProps<any>>>(AntList)``;

export const ListItem = styled<FC<ListItemProps>>(AntList.Item)``;
